import {
  getCurrentCompanyBranches,
  getCorporateBranchById,
  getCurrentCompanyCities,
  getCurrentCompanyStateProvinces,
  addCorporateBranch,
  updateCorporateBranch,
  deleteCorporateBranch,
  removeCorporateBranch,
  inviteBranchToCorporation,
} from '../utils/requests/companyAPI'

export const CORPORATE_LOAD_BRANCHES = 'CORPORATE_LOAD_BRANCHES'
export const CORPORATE_LOAD_BRANCHES_PENDING = 'CORPORATE_LOAD_BRANCHES_PENDING'
export const CORPORATE_LOAD_BRANCHES_FULFILLED = 'CORPORATE_LOAD_BRANCHES_FULFILLED'
export const CORPORATE_LOAD_BRANCHES_REJECTED = 'CORPORATE_LOAD_BRANCHES_REJECTED'

export const CORPORATE_LOAD_NEW_BRANCHES = 'CORPORATE_LOAD_NEW_BRANCHES'
export const CORPORATE_LOAD_NEW_BRANCHES_PENDING = 'CORPORATE_LOAD_NEW_BRANCHES_PENDING'
export const CORPORATE_LOAD_NEW_BRANCHES_FULFILLED = 'CORPORATE_LOAD_NEW_BRANCHES_FULFILLED'
export const CORPORATE_LOAD_NEW_BRANCHES_REJECTED = 'CORPORATE_LOAD_NEW_BRANCHES_REJECTED'

export const CORPORATE_LOAD_BRANCH_BY_ID = 'CORPORATE_LOAD_BRANCH_BY_ID'
export const CORPORATE_LOAD_BRANCH_BY_ID_PENDING = 'CORPORATE_LOAD_BRANCH_BY_ID_PENDING'
export const CORPORATE_LOAD_BRANCH_BY_ID_FULFILLED = 'CORPORATE_LOAD_BRANCH_BY_ID_FULFILLED'
export const CORPORATE_LOAD_BRANCH_BY_ID_REJECTED = 'CORPORATE_LOAD_BRANCH_BY_ID_REJECTED'

export const CORPORATE_LOAD_BRANCH_CITIES = 'CORPORATE_LOAD_BRANCH_CITIES'
export const CORPORATE_LOAD_BRANCH_CITIES_PENDING = 'CORPORATE_LOAD_BRANCH_CITIES_PENDING'
export const CORPORATE_LOAD_BRANCH_CITIES_FULFILLED = 'CORPORATE_LOAD_BRANCH_CITIES_FULFILLED'
export const CORPORATE_LOAD_BRANCH_CITIES_REJECTED = 'CORPORATE_LOAD_BRANCH_CITIES_REJECTED'

export const CORPORATE_LOAD_BRANCH_STATE_PROVINCES = 'CORPORATE_LOAD_BRANCH_STATE_PROVINCES'
export const CORPORATE_LOAD_BRANCH_STATE_PROVINCES_PENDING = 'CORPORATE_LOAD_BRANCH_STATE_PROVINCES_PENDING'
export const CORPORATE_LOAD_BRANCH_STATE_PROVINCES_FULFILLED = 'CORPORATE_LOAD_BRANCH_STATE_PROVINCES_FULFILLED'
export const CORPORATE_LOAD_BRANCH_STATE_PROVINCES_REJECTED = 'CORPORATE_LOAD_BRANCH_STATE_PROVINCES_REJECTED'

export const CORPORATE_POST_BRANCH = 'CORPORATE_POST_BRANCH'
export const CORPORATE_POST_BRANCH_PENDING = 'CORPORATE_POST_BRANCH_PENDING'
export const CORPORATE_POST_BRANCH_FULFILLED = 'CORPORATE_POST_BRANCH_FULFILLED'
export const CORPORATE_POST_BRANCH_REJECTED = 'CORPORATE_POST_BRANCH_REJECTED'

export const CORPORATE_PUT_BRANCH = 'CORPORATE_PUT_BRANCH'
export const CORPORATE_PUT_BRANCH_PENDING = 'CORPORATE_PUT_BRANCH_PENDING'
export const CORPORATE_PUT_BRANCH_FULFILLED = 'CORPORATE_PUT_BRANCH_FULFILLED'
export const CORPORATE_PUT_BRANCH_REJECTED = 'CORPORATE_PUT_BRANCH_REJECTED'

export const CORPORATE_DELETE_BRANCH = 'CORPORATE_DELETE_BRANCH'
export const CORPORATE_DELETE_BRANCH_PENDING = 'CORPORATE_DELETE_BRANCH_PENDING'
export const CORPORATE_DELETE_BRANCH_FULFILLED = 'CORPORATE_DELETE_BRANCH_FULFILLED'
export const CORPORATE_DELETE_BRANCH_REJECTED = 'CORPORATE_DELETE_BRANCH_REJECTED'

export const CORPORATE_REMOVE_BRANCH = 'CORPORATE_REMOVE_BRANCH'
export const CORPORATE_REMOVE_BRANCH_PENDING = 'CORPORATE_REMOVE_BRANCH_PENDING'
export const CORPORATE_REMOVE_BRANCH_FULFILLED = 'CORPORATE_REMOVE_BRANCH_FULFILLED'
export const CORPORATE_REMOVE_BRANCH_REJECTED = 'CORPORATE_REMOVE_BRANCH_REJECTED'

export const CORPORATE_INVITE_BRANCH = 'CORPORATE_INVITE_BRANCH'
export const CORPORATE_INVITE_BRANCH_PENDING = 'CORPORATE_INVITE_BRANCH_PENDING'
export const CORPORATE_INVITE_BRANCH_FULFILLED = 'CORPORATE_INVITE_BRANCH_FULFILLED'
export const CORPORATE_INVITE_BRANCH_REJECTED = 'CORPORATE_INVITE_BRANCH_REJECTED'

export const CORPORATE_CLEAR_BRANCH_MESSAGES = 'CORPORATE_CLEAR_BRANCH_MESSAGES'

export function loadCorporateBranches(companyId, queryParams, refetch = false) {
  return {
    type: refetch ? CORPORATE_LOAD_NEW_BRANCHES : CORPORATE_LOAD_BRANCHES,
    payload: getCurrentCompanyBranches(companyId, queryParams),
  }
}

export function loadCorporateBranchById(companyId, branchId) {
  return {
    type: CORPORATE_LOAD_BRANCH_BY_ID,
    payload: getCorporateBranchById(companyId, branchId),
  }
}

export function loadCorporateBranchCities(companyId) {
  return {
    type: CORPORATE_LOAD_BRANCH_CITIES,
    payload: getCurrentCompanyCities(companyId),
  }
}

export function loadCorporateBranchStateProvinces(companyId) {
  return {
    type: CORPORATE_LOAD_BRANCH_STATE_PROVINCES,
    payload: getCurrentCompanyStateProvinces(companyId),
  }
}

export function createCorporateBranch(companyId, bodyParams) {
  return {
    type: CORPORATE_POST_BRANCH,
    payload: addCorporateBranch(companyId, bodyParams),
  }
}

export function putCorporateBranch(companyId, branchId, bodyParams) {
  return {
    type: CORPORATE_PUT_BRANCH,
    payload: updateCorporateBranch(companyId, branchId, bodyParams),
  }
}

export function deleteBranchFromCorporation(companyId, branchId) {
  return {
    type: CORPORATE_DELETE_BRANCH,
    payload: deleteCorporateBranch(companyId, branchId),
    meta: { branchId },
  }
}

export function removeBranchFromCorporation(companyId, branchId) {
  return {
    type: CORPORATE_REMOVE_BRANCH,
    payload: removeCorporateBranch(companyId, branchId),
    meta: { branchId },
  }
}

export function clearCorporateBranchMessages() {
  return {
    type: CORPORATE_CLEAR_BRANCH_MESSAGES,
  }
}

export function inviteBranch(companyId, body) {
  return {
    type: CORPORATE_INVITE_BRANCH,
    payload: inviteBranchToCorporation(companyId, body),
  }
}
